import { render, staticRenderFns } from "./WasteDestination.vue?vue&type=template&id=170b3420&scoped=true&"
import script from "./WasteDestination.vue?vue&type=script&lang=js&"
export * from "./WasteDestination.vue?vue&type=script&lang=js&"
import style0 from "./WasteDestination.vue?vue&type=style&index=0&id=170b3420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b3420",
  null
  
)

export default component.exports